import './App.css';

import React, { useState } from 'react';

import Header from './components/Header.js';
import Footer from './components/Footer.js';
import CSVHandler from './api/csv_handler';
import RecordTable from './api/record_table';
import ReportGenerator from './api/report_generator';

function App() {

  const [parsedRecords, setParsedRecords] = useState(null);
  const [parsedQuestions, setParsedQuestions] = useState(null);
  const [selectedRecords, setSelectedRecords] = useState(null);

  const handleCSVDataParsed = (data) => {
    setParsedRecords(data[1]);
    setParsedQuestions(data[0]);
  };

  const handleSelectionSaved = (data) => {
    // console.log(data);
    setSelectedRecords(data);
  };

  const handleGoHome = () => {
    setParsedRecords(null);
    setParsedQuestions(null);
    setSelectedRecords(null);
  };
  
  return (
    <div className="App">
      <div className="App-inner">
        <Header />
        <div className='Content'>
          {!parsedRecords && <CSVHandler onCSVDataParsed={handleCSVDataParsed}/>}
          {parsedRecords && !selectedRecords && <RecordTable records={parsedRecords} questions={parsedQuestions} onSelectionSaved={handleSelectionSaved}/>}
          {selectedRecords && <ReportGenerator records={selectedRecords} onGoHome={handleGoHome}/>}
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default App;
